import { c as _c } from "react/compiler-runtime";
import React, { useState, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { differenceWith } from 'lodash';
import FlyoutContainer from 'components/consumer/FlyoutContainer';
import PDPFullWidthImageAndTextSelector from 'components/consumer/PDP/PDPFullWidthImageAndTextSelector';
import IconInfoNew from 'components/icons/IconInfoNew';
import { colorGrayLight2 } from 'styles/layout/colors';
import { PDP_READYTOSHIP_TAB_ID, WOOD_STAIN_PRODUCT_OPTION_ID, BED_SIZE_PRODUCT_OPTION_ID, BB_ORIENTATION_PRODUCT_OPTION_ID, FRAME_PRODUCT_OPTION_ID, ORIENTATION_PRODUCT_OPTION_ID } from 'commons/constants';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import { getCombinedOptionSKUs } from 'data-hooks/useProductLocalStock/utils';
import OrientationPDPModal, { orientationOptionIds } from '../../OrientationPDPModal';
import PDPImageAndTextOption from './PDPImageAndTextOption';
import usePDPOptions from '../state/context/usePDPOptions';
import usePdpSelectedOptionsVariantSku from '../state/pdpSelectedOptionsVariantSku/usePdpSelectedOptionsVariantSku';
const stockWithNonstockExceptions = (stockOptions, optionsWithNonstock) => {
  if (!stockOptions || !optionsWithNonstock) {
    return stockOptions;
  }
  const frameOptionInstock = stockOptions.find(option => option.id === FRAME_PRODUCT_OPTION_ID) || null;
  const frameOptionAll = optionsWithNonstock.find(option => option.id === FRAME_PRODUCT_OPTION_ID) || null;
  if (frameOptionInstock && frameOptionAll) {
    const nonStockOptionValues = differenceWith(frameOptionAll.values, frameOptionInstock.values, (allValue, instockValue) => allValue.id === instockValue.id).map(option => ({
      ...option,
      isDisabled: true
    }));
    const stockOptionsWithNonstockExceptions = stockOptions.map(option => {
      if (option.id === FRAME_PRODUCT_OPTION_ID) {
        const optionWithNonstockException = {
          ...option,
          values: [...option.values, ...nonStockOptionValues]
        };
        return optionWithNonstockException;
      }
      return option;
    });
    return stockOptionsWithNonstockExceptions;
  }
  return stockOptions;
};
const getContentForOptionValue = (optionValue, variant) => {
  if (variant === 'regular') {
    return {
      image: optionValue.image,
      text: optionValue.value.trim()
    };
  }
  if (variant === 'fullWidth') {
    return {
      image: optionValue.image,
      text: optionValue.value.trim(),
      price: `$${optionValue.additional_cost}`
    };
  }
  return {};
};
const findValuesFromOptions = (options, optionId, variant, selectedOptions, validStockOptionSkus, isRTSTab, productOptions) => {
  if (!options || !optionId) {
    return [];
  }
  const orderedSelectedOption = options.find(option => parseInt(option.id, 10) === parseInt(optionId, 10));
  if (!orderedSelectedOption) {
    return [];
  }

  /*
   * The selectedOptions object is received in a format like this: {16: 107, 17: 4561, 19: 757}
   * However, the backend system uses a different order to generate SKUs from options,
   * where the keys are manually reordered to match the backend's logic.
   */
  const orderedSelectedOptions = productOptions?.map(({
    id
  }) => ({
    id,
    value: selectedOptions[id.toString()]
  }));
  const selectedOptionKeys = orderedSelectedOptions.map(option => option.id);
  const optionIdPosition = selectedOptionKeys.indexOf(optionId);
  const otherOptionSkuArray = orderedSelectedOptions.filter(option => option.id !== optionId).map(({
    id,
    value
  }) => {
    const otherOption = options.find(option => parseInt(option.id, 10) === parseInt(id, 10));
    return otherOption.values.find(otherOptionValue => otherOptionValue.id === value).sku;
  });
  const updatedValues = orderedSelectedOption.values.map(optionValue => {
    const content = getContentForOptionValue(optionValue, variant);
    const combinedSku = [...otherOptionSkuArray];
    combinedSku.splice(optionIdPosition, 0, optionValue.sku);
    const isOutOfStock = !validStockOptionSkus?.includes(combinedSku.join(''));
    return {
      ...optionValue,
      content,
      isSelected: selectedOptions?.[orderedSelectedOption.id] === optionValue.id,
      isDisabled: isRTSTab && (isOutOfStock || optionValue?.isDisabled)
    };
  });
  return updatedValues;
};
const PDPImageAndTextOptionDisplay = t0 => {
  const $ = _c(79);
  const {
    hideFlyout: t1,
    imageOrTextVariant: t2,
    mode: t3,
    optionId: t4,
    variant: t5
  } = t0;
  const hideFlyout = t1 === undefined ? false : t1;
  const imageOrTextVariant = t2 === undefined ? "regular" : t2;
  const mode = t3 === undefined ? "pdp" : t3;
  const optionId = t4 === undefined ? null : t4;
  const variant = t5 === undefined ? "regular" : t5;
  const {
    loading,
    data: t6,
    actions
  } = usePDPOptions();
  let t7;
  if ($[0] !== t6) {
    t7 = t6 === undefined ? {} : t6;
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const data = t7;
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {};
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  const [flyOutContent, setFlyOutContent] = useState(t8);
  const [isFlyOutVisible, setIsFlyOutVisible] = useState(false);
  const containerRef = useRef(null);
  const [showOrientationPDPModal, setShowOrientationPDPModal] = useState(false);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const {
    options: t9,
    selectedOptions: t10,
    stock: t11
  } = data;
  let t12;
  if ($[3] !== t9) {
    t12 = t9 === undefined ? [] : t9;
    $[3] = t9;
    $[4] = t12;
  } else {
    t12 = $[4];
  }
  const options = t12;
  let t13;
  if ($[5] !== t10) {
    t13 = t10 === undefined ? {} : t10;
    $[5] = t10;
    $[6] = t13;
  } else {
    t13 = $[6];
  }
  const selectedOptions = t13;
  let t14;
  if ($[7] !== t11) {
    t14 = t11 === undefined ? {} : t11;
    $[7] = t11;
    $[8] = t14;
  } else {
    t14 = $[8];
  }
  const stock = t14;
  const isRTSTab = pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID;
  let t15;
  if ($[9] !== isRTSTab || $[10] !== options || $[11] !== stock) {
    t15 = isRTSTab ? stockWithNonstockExceptions(stock.stockOptions, options) : options;
    $[9] = isRTSTab;
    $[10] = options;
    $[11] = stock;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  const finalOptions = t15;
  const pdpSelectedOptionsVariantSku = usePdpSelectedOptionsVariantSku();
  let t16;
  bb0: {
    if (!!stock?.stockOptionsCombined?.length && isRTSTab) {
      const t17 = stock?.stockOptionsCombined;
      let t18;
      if ($[13] !== pdpSelectedOptionsVariantSku || $[14] !== t17) {
        t18 = getCombinedOptionSKUs(pdpSelectedOptionsVariantSku, t17);
        $[13] = pdpSelectedOptionsVariantSku;
        $[14] = t17;
        $[15] = t18;
      } else {
        t18 = $[15];
      }
      const updatedDisabledState = t18;
      t16 = updatedDisabledState;
      break bb0;
    }
    let t17;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = [];
      $[16] = t17;
    } else {
      t17 = $[16];
    }
    t16 = t17;
  }
  const validStockOptionSkus = t16;
  let t17;
  if ($[17] !== finalOptions || $[18] !== isRTSTab || $[19] !== optionId || $[20] !== options || $[21] !== selectedOptions || $[22] !== validStockOptionSkus || $[23] !== variant) {
    t17 = findValuesFromOptions(finalOptions, optionId, variant, selectedOptions, validStockOptionSkus, isRTSTab, options);
    $[17] = finalOptions;
    $[18] = isRTSTab;
    $[19] = optionId;
    $[20] = options;
    $[21] = selectedOptions;
    $[22] = validStockOptionSkus;
    $[23] = variant;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  const values = t17;
  let t18;
  if ($[25] !== hideFlyout || $[26] !== values) {
    t18 = (isVisible, optionValueId) => {
      if (hideFlyout) {
        return;
      }
      const newTop = containerRef?.current?.getBoundingClientRect().top || 0;
      const selectedValue = values?.find(t19 => {
        const {
          id
        } = t19;
        return id === optionValueId;
      });
      if (isVisible && selectedValue) {
        setFlyOutContent({
          top: newTop,
          imageUrl: selectedValue?.image,
          content: selectedValue?.description,
          title: selectedValue?.value.trim()
        });
      }
      setIsFlyOutVisible(isVisible);
    };
    $[25] = hideFlyout;
    $[26] = values;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  const toggleFlyOut = t18;
  let t19;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => {
      setIsFlyOutVisible(false);
    };
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  const onClose = t19;
  let t20;
  if ($[29] !== actions || $[30] !== optionId) {
    t20 = optionValueId_0 => {
      if (typeof actions?.onOptionValueSelection === "function") {
        actions.onOptionValueSelection(optionId, optionValueId_0);
      }
    };
    $[29] = actions;
    $[30] = optionId;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  const onOptionClicked = t20;
  let t21;
  if ($[32] !== optionId || $[33] !== options) {
    t21 = options?.find(option => option.id === optionId)?.name;
    $[32] = optionId;
    $[33] = options;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  const optionName = t21;
  const selectedId = selectedOptions?.[optionId];
  const t22 = `w-full flex-col flex ${optionId !== WOOD_STAIN_PRODUCT_OPTION_ID && optionId !== BED_SIZE_PRODUCT_OPTION_ID && optionId !== BB_ORIENTATION_PRODUCT_OPTION_ID && optionId !== ORIENTATION_PRODUCT_OPTION_ID && optionId !== FRAME_PRODUCT_OPTION_ID && values.length < 2 ? "hidden" : ""}`;
  const t23 = `Select ${optionName}`;
  let t24;
  if ($[35] !== optionId) {
    t24 = orientationOptionIds.includes(optionId) && <button type="button" onClick={() => {
      setShowOrientationPDPModal(true);
    }} className="cursor-pointer align-middle bg-transparent border-0"><IconInfoNew color={colorGrayLight2} width={13} height={13} /></button>;
    $[35] = optionId;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] !== t23 || $[38] !== t24) {
    t25 = <h3 className="text-base font-bold text-gray mt-0 mx-0 mb-1.5">{t23}{" "}{t24}</h3>;
    $[37] = t23;
    $[38] = t24;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  let t27;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {};
    t27 = [];
    $[40] = t26;
    $[41] = t27;
  } else {
    t26 = $[40];
    t27 = $[41];
  }
  const t28 = !!showOrientationPDPModal;
  let t29;
  let t30;
  let t31;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = () => {
      setShowOrientationPDPModal(false);
    };
    t30 = {};
    t31 = {};
    $[42] = t29;
    $[43] = t30;
    $[44] = t31;
  } else {
    t29 = $[42];
    t30 = $[43];
    t31 = $[44];
  }
  let t32;
  if ($[45] !== onOptionClicked) {
    t32 = id_0 => {
      onOptionClicked(id_0);
    };
    $[45] = onOptionClicked;
    $[46] = t32;
  } else {
    t32 = $[46];
  }
  let t33;
  if ($[47] !== optionId || $[48] !== t28 || $[49] !== t32 || $[50] !== values) {
    t33 = <OrientationPDPModal selectedPlan={t26} eligiblePlans={t27} isOpen={t28} close={t29} cartItemId={t30} isEdit={t31} onOptionClicked={t32} values={values} optionId={optionId} />;
    $[47] = optionId;
    $[48] = t28;
    $[49] = t32;
    $[50] = values;
    $[51] = t33;
  } else {
    t33 = $[51];
  }
  const t34 = mode === "quickview";
  const t35 = variant === "fullWidth";
  let t36;
  if ($[52] !== t34 || $[53] !== t35) {
    t36 = classnames("w-full flex items-start flex-row flex-nowrap overflow-x-scroll pr-2 lg:flex-wrap lg:pr-0", {
      "md:flex-wrap md:pr-0": t34,
      "flex-col": t35
    });
    $[52] = t34;
    $[53] = t35;
    $[54] = t36;
  } else {
    t36 = $[54];
  }
  let t37;
  if ($[55] !== flyOutContent || $[56] !== isFlyOutVisible) {
    t37 = isFlyOutVisible ? <FlyoutContainer top={flyOutContent.top} imageUrl={flyOutContent.imageUrl} content={flyOutContent.content} title={flyOutContent.title} isOpen={isFlyOutVisible} onClose={onClose} flyoutVariant="standard" /> : null;
    $[55] = flyOutContent;
    $[56] = isFlyOutVisible;
    $[57] = t37;
  } else {
    t37 = $[57];
  }
  let t38;
  if ($[58] !== loading) {
    t38 = loading ? [1, 2].map(val => <PDPImageAndTextOption loading={loading} key={val} />) : null;
    $[58] = loading;
    $[59] = t38;
  } else {
    t38 = $[59];
  }
  let t39;
  if ($[60] !== imageOrTextVariant || $[61] !== loading || $[62] !== onOptionClicked || $[63] !== optionName || $[64] !== selectedId || $[65] !== toggleFlyOut || $[66] !== values || $[67] !== variant) {
    t39 = !loading && values.length ? values.map(optionValue => {
      if (variant === "fullWidth") {
        return <PDPFullWidthImageAndTextSelector key={optionValue.id} value={optionValue} onClickAction={onOptionClicked} onHoverAction={toggleFlyOut} optionName={optionName} selectedId={selectedId} />;
      }
      return <PDPImageAndTextOption key={optionValue.id} optionValue={optionValue} selectedId={selectedId} onOptionValueSelection={onOptionClicked} variant={imageOrTextVariant} toggleFlyOut={toggleFlyOut} />;
    }) : null;
    $[60] = imageOrTextVariant;
    $[61] = loading;
    $[62] = onOptionClicked;
    $[63] = optionName;
    $[64] = selectedId;
    $[65] = toggleFlyOut;
    $[66] = values;
    $[67] = variant;
    $[68] = t39;
  } else {
    t39 = $[68];
  }
  let t40;
  if ($[69] !== t36 || $[70] !== t37 || $[71] !== t38 || $[72] !== t39) {
    t40 = <div className={t36} ref={containerRef}>{t37}{t38}{t39}</div>;
    $[69] = t36;
    $[70] = t37;
    $[71] = t38;
    $[72] = t39;
    $[73] = t40;
  } else {
    t40 = $[73];
  }
  let t41;
  if ($[74] !== t22 || $[75] !== t25 || $[76] !== t33 || $[77] !== t40) {
    t41 = <div className={t22}>{t25}{t33}{t40}</div>;
    $[74] = t22;
    $[75] = t25;
    $[76] = t33;
    $[77] = t40;
    $[78] = t41;
  } else {
    t41 = $[78];
  }
  return t41;
};
PDPImageAndTextOptionDisplay.propTypes = {
  hideFlyout: PropTypes.bool,
  imageOrTextVariant: PropTypes.oneOf(['regular', 'textOnly']),
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  optionId: PropTypes.number,
  variant: PropTypes.oneOf(['regular', 'fullWidth']),
  values: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.shape({
      displayValue: PropTypes.string,
      modifier: PropTypes.string,
      type: PropTypes.oneOf(['image', 'text'])
    })),
    isSelected: PropTypes.bool
  })
};
export default PDPImageAndTextOptionDisplay;